import React, {useContext, useEffect, useState} from "react";
import {Box, Button, Flex, Text} from "rebass";
import {Form, Formik} from "formik";
import {
  CardFooter,
  Modal,
  DateInput,
  RadioInput,
} from "../Components";
import {AuthContext, PatientsContext, TourContext, TourName} from "../Contexts";
import "./ManageHeadsetsModal.css"

type HelpContent = { [key in TourName]: string }

const emptyHelp: HelpContent = {
  "Overview": "Aenean a felis sit amet nunc consequat eleifend ut in neque. ",
  "Creating a new Patient": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vestibulum, lectus sed ultricies suscipit, est leo sagittis orci, id ornare erat leo sit amet nunc. Nullam pretium dignissim purus, eu dignissim diam mattis sed. Ut ultrices justo ultricies tortor finibus, quis consequat arcu tincidunt. Duis placerat maximus fringilla. Fusce scelerisque volutpat lectus, et vulputate odio elementum sed. Nulla tincidunt justo id orci tincidunt, at interdum mauris ullamcorper. Maecenas feugiat, arcu sit amet vehicula efficitur, libero metus dictum erat, gravida rhoncus orci quam non risus. Fusce sagittis augue augue, et condimentum dolor cursus a. Sed ullamcorper, nisl eget laoreet commodo, turpis arcu cursus purus, vel consequat erat velit vel mauris. Suspendisse potenti. Pellentesque ultrices nunc eget faucibus rhoncus. Sed felis tellus, convallis id sodales non, convallis id augue.",
  "Archiving and Restoring Patients": "Cras ut lacus id sem posuere malesuada at vitae risus. Integer lacinia leo id iaculis ornare. Vivamus lacinia, sem quis porttitor tincidunt, urna nibh vestibulum sapien, non accumsan velit nulla nec dolor.",
  "Managing Configurations": "Etiam non finibus elit. Aliquam hendrerit, sem sit amet fermentum tincidunt, nibh urna lacinia justo, nec auctor nisl lectus non quam. Curabitur aliquam diam sit amet lobortis ultricies. Aenean a enim congue, pulvinar mi id, fringilla metus. Mauris et dapibus ligula. Aenean porttitor, augue non euismod aliquam, purus diam sagittis dolor, id faucibus tellus nunc ac libero. Cras nec ullamcorper massa. Vivamus condimentum magna vel magna dignissim suscipit. Aliquam erat volutpat. Duis est dolor, cursus id felis lobortis, pulvinar sollicitudin ipsum. Donec bibendum pulvinar augue, ut tincidunt mauris blandit non. Duis ultricies sollicitudin luctus. Pellentesque semper orci sed dui cursus ullamcorper.",
}

const fetchHelp: () => Promise<HelpContent> = async () => {
  return emptyHelp
}

export const HelpModal: React.FC<{
  isOpen: boolean;
  setIsOpen: (b: boolean) => void;
}> = ({isOpen, setIsOpen}) => {
  const authContext = useContext(AuthContext);
  let uid: string = authContext.user != null ? authContext.user.user_id : "";

  const [helpContent, setHelpContent] = useState<HelpContent>(emptyHelp);

  // get help content on first render
  useEffect(() => {
    fetchHelp().then((newHelpContent) => setHelpContent(newHelpContent))
  }, [])

  return (
    <>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} headerText="Help">
        <div style={{overflow: "auto", height: "50vh", width: "40vw"}}>
          {Object.keys(helpContent).map(title =>
            <ExpandableCard
              title={title}
              body={helpContent[title]}
              closeModal={() => setIsOpen(false)}
              key={"expandableCard" + title}
            />
          )}
        </div>
      </Modal>
    </>
  )
}

const ExpandableCard: React.FC<{
  title: string
  body: string
  closeModal: () => void
}> = ({title, body, closeModal}) => {
  const tourContext = useContext(TourContext);

  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <div style={{margin: "18px"}}>
      <Flex alignItems="center" alignContent="center" justifyItems="space-between" justifyContent="space-between">
        <Flex alignItems="center" alignContent="center"
              sx={{cursor: "pointer"}}
              onClick={(e) => {
                setIsOpen(!isOpen)
              }}
        >
          <img className="svg_button" src="/ui/expand.svg" alt="expand"
               style={{
                 width: "28px",
                 marginRight: "18px",
                 transform: "scale(" + (isOpen? -1:1) + ")"
               }}
          />
          <Text fontWeight="bold" fontSize={[2, 4]} color="primary">{title}</Text>
        </Flex>
        {/*@ts-ignore*/}
        <Button onClick={() => {closeModal(); tourContext.openTour(title)}} variant="secondary">Open Tour</Button>
      </Flex>

      <div style={{
        marginTop: "6px",
        marginLeft: "48px"
      }}>
        {isOpen? <Text color="darkBlue">{body}</Text> : undefined}
      </div>

    </div>
  );
};

